<template>
  <div id="app">
    <div class="topbar">
      <div class="noise-chart">
        <router-link to="/">소음 그래프</router-link>
      </div>
      <div class="noise-chart">
        <router-link to="/average">등가 소음</router-link>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}

</script>

<style>
*{
  padding: 0;
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.topbar{
  width: 100%;
  height: 50px;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
}
.noise-chart{
  width: 120px;
  height: 30px;
  background-color: #454545;
  color: white;
  border-radius: 10px;
  display: inline-block;
  box-sizing: border-box;
  padding: 5px 0 0 0;
}
a{
  text-decoration: none;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/App.vue